import { ajax } from '../../util'

export function getArticleDetailSuccess(data: object) {
    return {
        type: 'ARTICLE_DETAIL_SUCCESS',
        data
    }
}

export function isGettingArticleDetail(data: boolean) {
    return {
        type: 'ARTICLE_DETAIL',
        data
    }
}

export function getArticleDetailError(data: string) {
    return {
        type: 'ARTICLE_DETAIL_ERROR',
        data
    }
}

export function getArticleDetail(id: any) {
    return (dispatch: any) => {
        dispatch(isGettingArticleDetail(true))
        const url = '/api/research_report/get_report_detail/' + id + '/'
        ajax(url, {}, 'GET').then(res => {
            if (res.hasError) {
                dispatch(getArticleDetailError(res[Object.keys(res)[0]]))
            } else {
                if (res.attachment_content && res.attachment_content['table_t1']) {
                    let attachmentKey = ['table_t1', 'table_t2', 'table_t3', 'table_t4', 'table_t5', 'table_t6', 'table_t7', 'table_t8', 'table_t9', 'table_t10', 'table_t11', 'table_t12']
                    let attachments = []
                    for (let i = 0; i < attachmentKey.length; i++) {
                        if (res.attachment_content[attachmentKey[i]]) {
                            attachments.push(res.attachment_content[attachmentKey[i]])
                        }
                    }
                    dispatch(getArticleDetailSuccess(
                        // {...res, attachment_content: Object.keys(attachments).map(key => attachments[key])}
                        {...res, attachment_content: attachments}
                    ))
                } else {
                    dispatch(getArticleDetailSuccess(res))
                }
            }
            dispatch(isGettingArticleDetail(false))
        })
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/scenes/ArticleDetail/actions.tsx